module.exports = __webpack_public_path__ + "img/msg_header.445aee48.jpg";